import { render } from "./Pagination.vue?vue&type=template&id=171493d0&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=171493d0&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171493d0"],['__file',"src/assets/js/components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "171493d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('171493d0', __exports__)) {
    api.reload('171493d0', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=171493d0&scoped=true", () => {
    api.rerender('171493d0', render)
  })

}


export default __exports__